import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import { Reveal, Eyebrow } from "../components/Reveal";
import { HiFinalCta } from "./HindiHome";

const HI_SERVICE_DETAILS = [
    {
        num: "01",
        slug: "brand-strategy",
        title: "ब्रांड स्ट्रैटेजी",
        short: "बिज़नेस लक्ष्य के अनुसार पोज़िशनिंग, कम्युनिकेशन, कैंपेन थिंकिंग और ब्रांड-बिल्डिंग।",
        details: [
            "आपके बाज़ार के अनुसार ब्रांड पोज़िशनिंग और वैल्यू प्रोपोज़िशन",
            "कम्युनिकेशन स्ट्रैटेजी — क्या कहना है, किससे, और वही क्यों जीतेगा",
            "ब्रांड को बिज़नेस लक्ष्यों से जोड़ने वाली कैंपेन थिंकिंग",
            "ब्रांड पहचान की दिशा और मैसेजिंग फ़्रेमवर्क",
        ],
        outcome: "ऐसा बिज़नेस जिसे जानबूझकर चुना जाए — सिर्फ़ दाम पर तुला न जाए।",
    },
    {
        num: "02",
        slug: "retail-trade-marketing",
        title: "रिटेल और ट्रेड मार्केटिंग",
        short: "रिटेल विज़िबिलिटी, डीलर/डिस्ट्रीब्यूटर एक्टिवेशन, मर्चंडाइज़िंग और मार्केट एक्ज़ीक्यूशन।",
        details: [
            "रिटेल विज़िबिलिटी और इन-स्टोर प्रेज़ेंस की प्लानिंग",
            "डीलर और डिस्ट्रीब्यूटर एक्टिवेशन प्रोग्राम",
            "मर्चंडाइज़िंग और पॉइंट-ऑफ़-सेल कम्युनिकेशन",
            "नर्मदापुरम, इतारसी और आसपास के इलाकों में मार्केट एक्ज़ीक्यूशन",
        ],
        outcome: "आपका ब्रांड वहाँ दिखे और बिके, जहाँ ख़रीद के फ़ैसले होते हैं।",
    },
    {
        num: "03",
        slug: "digital-growth",
        title: "डिजिटल ग्रोथ",
        short: "सोशल मीडिया, वेबसाइट, लैंडिंग पेज, कंटेंट, Google और Meta कैंपेन और डिजिटल स्ट्रैटेजी।",
        details: [
            "बिज़नेस लक्ष्यों से जुड़ी डिजिटल स्ट्रैटेजी — पोस्टिंग कैलेंडर नहीं",
            "ऐसी वेबसाइट और लैंडिंग पेज जो विज़िटर को enquiry में बदलें",
            "लोकल टारगेटिंग के साथ Google और Meta विज्ञापन",
            "ऐसा कंटेंट और सोशल मीडिया जो भरोसा बनाए, सिर्फ़ गतिविधि नहीं",
        ],
        outcome: "ऐसी डिजिटल मौजूदगी जो enquiries दे — दिखावटी आंकड़े नहीं।",
    },
    {
        num: "04",
        slug: "customer-acquisition",
        title: "कस्टमर एक्विज़िशन",
        short: "हाइपरलोकल कैंपेन, लीड जनरेशन, डिजिटल विज्ञापन और ग्राहक बढ़ाने की रणनीतियां।",
        details: [
            "आपके असली catchment area के अनुसार हाइपरलोकल कैंपेन",
            "साफ़ फ़ॉलो-अप प्रक्रिया वाले लीड जनरेशन सिस्टम",
            "लोकल SEO और Google Business Profile ऑप्टिमाइज़ेशन",
            "पहले संपर्क से बिक्री तक मापा गया acquisition फ़नल",
        ],
        outcome: "नए ग्राहकों का अनुमानित प्रवाह — क़िस्मत के उछाल नहीं।",
    },
    {
        num: "05",
        slug: "sales-growth",
        title: "सेल्स ग्रोथ",
        short: "enquiries, ग्राहकों, कन्वर्ज़न और बिज़नेस ग्रोथ पर केंद्रित मार्केटिंग — दिखावटी आंकड़े नहीं।",
        details: [
            "रेवेन्यू लक्ष्यों से जुड़ी सेल्स-फ़ोकस्ड मार्केटिंग योजनाएँ",
            "enquiry से कन्वर्ज़न तक के सफ़र की जाँच और सुधार",
            "ऑफर, प्राइसिंग-कम्युनिकेशन और प्रमोशन स्ट्रैटेजी",
            "ऐसे मेज़रमेंट फ़्रेमवर्क जो सच में ज़रूरी चीज़ें मापें",
        ],
        outcome: "मार्केटिंग उन्हीं आंकड़ों के प्रति जवाबदेह, जिनके प्रति आपका बिज़नेस है।",
    },
];

const HindiServices = () => {
    useEffect(() => {
        document.title = "सेवाएँ | ब्रांड स्ट्रैटेजी, रिटेल, डिजिटल और सेल्स ग्रोथ — ALBL नर्मदापुरम";
    }, []);

    return (
        <main lang="hi">
            <section className="bg-[#0D131F] hero-grid text-white pt-32 sm:pt-40 pb-16 sm:pb-24">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
                    <Reveal>
                        <Eyebrow dark>सेवाएँ</Eyebrow>
                        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight leading-[1.15] mt-5 max-w-4xl" data-testid="hi-services-hero-heading">
                            ब्रांड थिंकिंग से लेकर सेल्स एक्ज़ीक्यूशन तक।
                        </h1>
                        <p className="mt-6 text-slate-400 text-base sm:text-lg max-w-2xl leading-relaxed">
                            पाँच जुड़े हुए सर्विस एरिया। हर काम आपके बिज़नेस लक्ष्य के अनुसार — किसी पैकेज के अनुसार नहीं।
                        </p>
                    </Reveal>
                </div>
            </section>

            <section className="bg-white">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-20 sm:py-28 space-y-6">
                    {HI_SERVICE_DETAILS.map((s, i) => (
                        <Reveal key={s.slug} delay={i * 40}>
                            <article
                                id={s.slug}
                                data-testid={`hi-service-detail-${i + 1}`}
                                className={`grid lg:grid-cols-12 gap-10 border border-slate-200 p-8 sm:p-12 scroll-mt-28 ${
                                    i % 2 === 1 ? "bg-[#F8FAFC]" : "bg-white"
                                }`}
                            >
                                <div className="lg:col-span-4">
                                    <span className="font-serif-accent italic text-4xl text-[#C5A059]">{s.num}</span>
                                    <h2 className="font-display text-2xl sm:text-3xl font-extrabold tracking-tight text-slate-900 mt-4">
                                        {s.title}
                                    </h2>
                                    <p className="mt-4 text-slate-600 text-sm sm:text-base leading-relaxed">{s.short}</p>
                                </div>
                                <div className="lg:col-span-5">
                                    <p className="text-xs tracking-[0.25em] uppercase font-semibold text-[#1E3A8A] mb-5">
                                        क्या-क्या शामिल है
                                    </p>
                                    <ul className="space-y-4">
                                        {s.details.map((d) => (
                                            <li key={d} className="flex gap-3 items-start">
                                                <Check className="h-4 w-4 text-[#C5A059] mt-1 shrink-0" />
                                                <span className="text-sm sm:text-base text-slate-700 leading-relaxed">{d}</span>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                                <div className="lg:col-span-3 flex flex-col justify-between gap-8">
                                    <div>
                                        <p className="text-xs tracking-[0.25em] uppercase font-semibold text-[#1E3A8A] mb-4">
                                            नतीजा
                                        </p>
                                        <p className="font-serif-accent italic text-lg text-slate-800 leading-relaxed">{s.outcome}</p>
                                    </div>
                                    <Link
                                        to={`/hi/contact?intent=${encodeURIComponent(s.title)}`}
                                        data-testid={`hi-service-cta-${s.slug}`}
                                        className="btn-sharp inline-flex items-center gap-2 text-xs font-bold tracking-[0.15em] uppercase text-[#0D131F]"
                                    >
                                        इस पर बात करें <ArrowRight className="h-4 w-4 text-[#C5A059]" />
                                    </Link>
                                </div>
                            </article>
                        </Reveal>
                    ))}
                </div>
            </section>

            <HiFinalCta />
        </main>
    );
};

export default HindiServices;
